import React, { useState } from "react";
import ConfigureNotificationModal from "../modals/ConfigureNotificationMainModal";
import { Add } from "@mui/icons-material";
import { useNotificationAction } from "../../hooks/useNotificationAction";
import EmailNotificationUI from "./EmailNotificationUI";
import SlackNotificationUI from "./SlackNotificationUI";
import SmsNotificationUI from "./SmsNotificationUI";
import FrontNotificationUI from "./FrontNotificationUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

const Notification = ({
  route,
  setRoute,
  setSnackMsg,
  setOpenSnack,
  setLoader,
  hasValidationError = false,
}) => {
  const [
    openConfigureNotificationMainModal,
    setOpenConfigureNotificationMainModal,
  ] = useState(false);

  const routeModals = useRouteConfigModals();
  const [localChannels] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.channels?.L || []
  );
  const channels = routeModals?.channels ?? localChannels;
  const notificationLogic = useNotificationAction(null, 'root', route, setRoute);
  const addEmailChannelOption = routeModals
    ? { label: "Add Email Channel", onClick: () => routeModals.openAddChannelModal("email", notificationLogic.handleChannelChange) }
    : undefined;
  const addSlackChannelOption = routeModals
    ? { label: "Add Slack Channel", onClick: () => routeModals.openAddChannelModal("slack", notificationLogic.handleChannelChange) }
    : undefined;
  const addSmsChannelOption = routeModals
    ? { label: "Add SMS Channel", onClick: () => routeModals.openAddChannelModal("sms", notificationLogic.handleChannelChange) }
    : undefined;
  const addFrontChannelOption = routeModals
    ? { label: "Add Front Channel", onClick: () => routeModals.openAddChannelModal("front", notificationLogic.handleChannelChange) }
    : undefined;

  return (
    <div className="lg:w-[740px] w-full mt-5">
      <div className="text-lg font-semibold text-gray-900 mb-2">
        Notification
      </div>
      <ConfigureNotificationModal
        open={openConfigureNotificationMainModal}
        onClose={setOpenConfigureNotificationMainModal}
        slot={(newAction) =>
          setRoute((prev) => ({
            ...prev,
            primaryNotification: newAction,
            primaryChannel: null,
          }))
        }
      />

      {/* Notification */}
      {!route?.primaryNotification && (
        <div className="">
          <div className={`rounded-lg border-2 border-gray-200 py-8 px-4 shadow-sm ${hasValidationError ? "bg-red-50/80" : "bg-white"}`}>
            <div
              className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
                             flex items-center justify-center h-16 hover:border-gray-400 transition"
              onClick={() => setOpenConfigureNotificationMainModal(true)}
            >
              <Add className="text-gray-500 mr-2" />
              <span className="text-gray-600">Add Notification</span>
            </div>
          </div>
        </div>
      )}

      {route?.primaryNotification == "email" && (
        <EmailNotificationUI
          {...notificationLogic}
          setOpenConfigureNotificationModal={setOpenConfigureNotificationMainModal}
          channels={channels}
          hasValidationError={hasValidationError}
          addChannelOption={addEmailChannelOption}
        />
      )}

      {route?.primaryNotification == "slack" && (
        <SlackNotificationUI
          {...notificationLogic}
          setOpenConfigureNotificationModal={setOpenConfigureNotificationMainModal}
          channels={channels}
          hasValidationError={hasValidationError}
          addChannelOption={addSlackChannelOption}
        />
      )}

      {route?.primaryNotification == "sms" && (
        <SmsNotificationUI
          {...notificationLogic}
          setOpenConfigureNotificationModal={setOpenConfigureNotificationMainModal}
          channels={channels}
          hasValidationError={hasValidationError}
          addChannelOption={addSmsChannelOption}
        />
      )}

      {route?.primaryNotification == "front" && (
        <FrontNotificationUI
          {...notificationLogic}
          setOpenConfigureNotificationModal={setOpenConfigureNotificationMainModal}
          channels={channels}
          hasValidationError={hasValidationError}
          addChannelOption={addFrontChannelOption}
        />
      )}
    </div>
  );
};

export default Notification;
